import { createTheme } from "@mui/material/styles";

export const FONT = "Inter, Roboto, 'Helvetica Neue', Arial, sans-serif";

/** Shared design tokens; components reach for these instead of ad-hoc hex values. */
export const tokens = {
  ink: "#111111",
  text: "#1a1a1a",
  muted: "#6b7280",
  faint: "#9ca3af",
  border: "#ececec",
  surface: "#ffffff",
  subtle: "#f4f4f5",
  page: "#fafafa",
  gold: "#b7860b",
  win: "#16a34a",
  draw: "#9ca3af",
  loss: "#dc2626",
  radius: { sm: 8, md: 12, lg: 16, pill: 999 },
  shadow: {
    card: "0 1px 2px rgba(16,24,40,0.04), 0 4px 14px rgba(16,24,40,0.05)",
    raised: "0 2px 4px rgba(16,24,40,0.06), 0 10px 24px rgba(16,24,40,0.08)",
  },
};

const theme = createTheme({
  palette: {
    mode: "light",
    background: { default: tokens.page, paper: tokens.surface },
    primary: { main: "#000000" },
    secondary: { main: "#333333" },
    success: { main: tokens.win },
    error: { main: tokens.loss },
    text: { primary: tokens.text, secondary: "#666666" },
    divider: tokens.border,
  },
  typography: {
    fontFamily: FONT,
    h1: { fontWeight: 900, letterSpacing: "-0.03em" },
    h2: { fontWeight: 900, letterSpacing: "-0.025em" },
    h3: { fontWeight: 800, letterSpacing: "-0.02em" },
    h4: { fontWeight: 800, letterSpacing: "-0.02em" },
    h5: { fontWeight: 800, letterSpacing: "-0.01em" },
    h6: { fontWeight: 700 },
    button: { textTransform: "none", fontWeight: 700 },
  },
  components: {
    MuiButtonBase: {
      styleOverrides: {
        root: {
          transition: "transform 120ms ease, background-color 150ms ease, box-shadow 150ms ease",
          "&:active": { transform: "scale(0.97)" },
          "@media (prefers-reduced-motion: reduce)": { "&:active": { transform: "none" } },
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
    },
    MuiSkeleton: {
      defaultProps: { animation: "wave" },
      styleOverrides: { root: { backgroundColor: "rgba(0,0,0,0.06)" } },
    },
    MuiTooltip: {
      styleOverrides: { tooltip: { fontFamily: FONT, fontWeight: 600, borderRadius: 8 } },
    },
  },
});

export default theme;
